import { Calendar, MapPin } from "lucide-react";
import { useLang } from "@/landing/LanguageContext";
import { Reveal, Overline, CTAButton } from "@/landing/ui";

const toneClass = {
  open: "bg-carbon text-cream",
  few: "bg-sand text-carbon",
  soon: "border border-earth/40 text-earth",
  done: "border border-earth/30 text-earth/50",
};

const EditionsSection = () => {
  const { t } = useLang();
  const e = t.editions;

  return (
    <section id="ediciones" className="scroll-mt-20 bg-cream py-24 text-carbon lg:py-32" data-testid="editions-section">
      <div className="mx-auto max-w-5xl px-6 lg:px-10">
        <Reveal className="mb-12 max-w-2xl">
          <Overline>{e.overline}</Overline>
          <h2 className="mt-5 font-serif text-3xl font-light leading-tight md:text-4xl lg:text-5xl">
            {e.title}
          </h2>
          <p className="mt-6 font-sans text-base font-light leading-relaxed text-earth lg:text-lg">
            {e.subtitle}
          </p>
        </Reveal>

        <div className="border-t border-earth/20">
          {e.list.map((ed, i) => (
            <Reveal key={i} delay={i * 0.07}>
              <div className={`grid grid-cols-1 items-center gap-5 border-b border-earth/20 py-8 lg:grid-cols-12 lg:gap-6 lg:py-10 ${ed.tone === "done" ? "opacity-50" : ""}`}>
                <div className="flex items-center gap-3 lg:col-span-3">
                  <Calendar size={18} className="shrink-0 text-earth/60" />
                  <span className="font-serif text-2xl font-light text-carbon lg:text-3xl">
                    {ed.date}
                  </span>
                </div>

                <div className="lg:col-span-5">
                  <h3 className="font-serif text-xl font-light text-carbon">{ed.name}</h3>
                  <div className="mt-2 flex flex-wrap items-center gap-x-4 gap-y-1 font-sans text-sm font-light text-earth">
                    <span className="flex items-center gap-1.5">
                      <MapPin size={14} className="text-earth/60" /> {ed.location}
                    </span>
                    <span className="text-earth/50">·</span>
                    <span>{ed.format}</span>
                  </div>
                </div>

                <div className="lg:col-span-2">
                  <span
                    className={`inline-block px-4 py-1.5 font-sans text-xs tracking-[0.14em] uppercase ${toneClass[ed.tone]}`}
                  >
                    {ed.status}
                  </span>
                </div>

                <div className="lg:col-span-2 lg:text-right">
                  {ed.tone !== "done" && (
                    <CTAButton
                      testid={`edition-cta-${i}`}
                      source={`edition-${i}`}
                      variant="outline"
                      className="w-full lg:w-auto"
                    >
                      {e.cta}
                    </CTAButton>
                  )}
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <p className="mt-6 font-sans text-xs font-light text-earth/60">{e.note}</p>
        </Reveal>
      </div>
    </section>
  );
};

export default EditionsSection;
